module.exports = __webpack_public_path__ + "img/avi.0256c4d2.svg";